import { render, staticRenderFns } from "./partners.vue?vue&type=template&id=6577a2b3&scoped=true&"
import script from "./partners.vue?vue&type=script&lang=js&"
export * from "./partners.vue?vue&type=script&lang=js&"
import style0 from "./partners.vue?vue&type=style&index=0&id=6577a2b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6577a2b3",
  null
  
)

export default component.exports